import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteAnticipoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='ANTICIPO' htmlFor='input-importeAnticipo' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber id='input-importeAnticipo' name='input-importeAnticipo' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteAnticipoFormGroup)
